import { View, useColorScheme } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import MyBottomSheet from '../components/bottomSheet';

export default function MapScreen() {
  const colorScheme = useColorScheme();

  return (
    <View style={{ height: '100%' }}>
      <StatusBar style={colorScheme === 'light' ? 'dark' : 'light'} />
      <MyBottomSheet />
    </View>
  );
}
